import { DateTime } from "luxon";
import type { InvoiceEntity } from "../api/types";
import type { InvoiceSort } from "../pages/Admin/InvoicesPage/types";

export type InvoiceMonthGroup = {
  month: string;
  items: InvoiceEntity[];
};

const UNGROUPED = "Ungrouped";

const monthLabel = (invoice: InvoiceEntity, sortBy: InvoiceSort): string => {
  if (sortBy === "nameAsc") return UNGROUPED;
  const iso =
    sortBy === "receivedDateDesc" ? invoice.dateReceived : invoice.dueDate;
  const dt = DateTime.fromISO(iso);
  return dt.isValid ? dt.toFormat("MMMM yyyy") : UNGROUPED;
};

export const groupInvoicesByMonth = (
  invoices: InvoiceEntity[],
  sortBy: InvoiceSort,
): InvoiceMonthGroup[] => {
  const groups: InvoiceMonthGroup[] = [];
  let current: InvoiceMonthGroup | null = null;
  for (const item of invoices) {
    const label = monthLabel(item, sortBy);
    if (!current || current.month !== label) {
      current = { month: label, items: [] };
      groups.push(current);
    }
    current.items.push(item);
  }
  return groups;
};
